import { React, useEffect, useState } from 'react'
import App from '../../layout/App';
import {
    FormContent, Container, Box,
    Box2Items, Box3Items,
    Select, Option, TitleFieldForm,
    Box50, Box30, TextLabel,
    Message, Madatory
} from '../../styles/styles'
import Checkbox from '../../Components/checkbox'
import { useNavigate } from 'react-router-dom';
import InputResponsive1 from '../../Components/InputResponsive1';
import '../../styles/styles.css';
import Loading from '../../Components/Loading';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import MessagePopUp from '../../Components/messagePopUp';
import IdentificacaoEscola from './EditarIdentificacao';
import { IsNone } from '../../utils/functions';
import InfoForm from '../../Components/infoForm';
import ButtonFormFooter from '../../Components/buttonFormFooter';
import { escolaJson } from '../../utils/objectJson';
import { validationForm2 } from '../../utils/validationSchool';
import { useIndexedLabels } from '../../utils/useIndexedLabels';

function Form2Escola() {
    const {
        getTitleIndex,
        getIndexByLabel,
    } = useIndexedLabels();
    const [removeLoad, setRemoveLoad] = useState(false)
    const navigation = useNavigate();

    const [messageRequired, setMessageRequired] = useState([])
    const [CaracterizacaoEscola, setCaracterizacaoEscola] = useState(escolaJson)
    const { register, handleSubmit, setValue, formState: { errors } } = useForm({
        resolver: yupResolver(validationForm2)
    });

    const onSubmit = data => {
        setRemoveLoad(false)
        setTimeout(function () {
            sessionStorage.setItem('EscolaEditar', JSON.stringify(CaracterizacaoEscola))
            if (sessionStorage.getItem('EscolaEditar') !== undefined);
            setRemoveLoad(true)
            navigation('/escola/editar-organizacao')
        }, 1000); // O valor é representado em milisegundos.
    };

    useEffect(() => {
        setRemoveLoad(true)
        let Escola = JSON.parse(sessionStorage.getItem('EscolaEditar'))
        setCaracterizacaoEscola(Escola)
    }, [])

    useEffect(() => {
        if (errors) {
            const entries = Object.entries(errors).map(([key, error]) => ({
                id: key + '-' + error.message,
                fieldName: key,
                error,
            }));
            setMessageRequired(entries);
        }
    }, [errors]);


    console.log('validations:', errors)
    return (
        <>
            {!removeLoad && <Loading />}
            <div className='span-message'>
                {messageRequired.map(({ id, fieldName, error }) => {
                    const idx = getIndexByLabel(fieldName) || "";
                    const text = error.message;

                    return (
                        <MessagePopUp
                            key={id}
                            title={`Campo ${idx} - obrigatório`}
                            text={text}
                            onClose={() =>
                                setMessageRequired(prev => prev.filter(m => m.id !== id))
                            }
                        />
                    );
                })}
            </div>
            <App>
                <Container>
                    <InfoForm
                        title={'Escola'}
                        wasChanged={CaracterizacaoEscola.wasChanged}
                        positionPagination={'2/3'}
                        subtitle={'Caracterização'}
                    />
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <FormContent>
                            <Box>
                                <TitleFieldForm>
                                    {getTitleIndex('Local de funcionamento  da escola (Assinalar mais de uma opção se for o caso)', 'workingPlace')} <Madatory>*</Madatory>
                                </TitleFieldForm>
                                <Checkbox title='Prédio escolar'
                                    value={'predioEscolar'}
                                    name={'workingPlace[0]'}
                                    setValue={setValue('workingPlace[0]', CaracterizacaoEscola.headQuarters.workingPlace.schoolBuilding === 1 ? 'predioEscolar' : 0)}
                                    register={register('workingPlace[0]')}
                                    checked={CaracterizacaoEscola.headQuarters.workingPlace.schoolBuilding === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, workingPlace: {
                                                ...CaracterizacaoEscola.headQuarters.workingPlace,
                                                schoolBuilding: e.target.checked ? 1 : 0,
                                                prisonUnit: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Sala(s) em outra escola'
                                    value={"outra Escola"}
                                    name={'workingPlace[1]'}
                                    setValue={setValue('workingPlace[1]', CaracterizacaoEscola.headQuarters.workingPlace.classOtherSchool === 1 ? 'outraEscola' : 0)}
                                    checked={CaracterizacaoEscola.headQuarters.workingPlace.classOtherSchool === 1 ? true : false}
                                    register={register('workingPlace[1]')}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, workingPlace: {
                                                ...CaracterizacaoEscola.headQuarters.workingPlace,
                                                classOtherSchool: e.target.checked ? 1 : 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Galpão/rancho/paiol/barracão'
                                    value={"galpão"}
                                    name={'workingPlace[2]'}
                                    setValue={setValue('workingPlace[2]', CaracterizacaoEscola.headQuarters.workingPlace.shed)}
                                    checked={CaracterizacaoEscola.headQuarters.workingPlace.shed === 1 ? true : false}
                                    register={register('workingPlace[2]')}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, workingPlace: {
                                                ...CaracterizacaoEscola.headQuarters.workingPlace,
                                                shed: e.target.checked ? 1 : 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Unidade de atendimento socioeducativo'
                                    value={"socioeducativo"}
                                    name={'workingPlace[3]'}
                                    setValue={setValue('workingPlace[3]', CaracterizacaoEscola.headQuarters.workingPlace.socioEducationalUnit)}
                                    checked={CaracterizacaoEscola.headQuarters.workingPlace.socioEducationalUnit === 1 ? true : false}
                                    register={register('workingPlace[3]')}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, workingPlace: {
                                                ...CaracterizacaoEscola.headQuarters.workingPlace,
                                                socioEducationalUnit: e.target.checked ? 1 : 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Unidade prisional'
                                    value={"unidade Prisional"}
                                    name={'workingPlace[4]'}
                                    setValue={setValue('workingPlace[4]', CaracterizacaoEscola.headQuarters.workingPlace.prisonUnit)}
                                    checked={CaracterizacaoEscola.headQuarters.workingPlace.prisonUnit === 1 ? true : false}
                                    register={register('workingPlace[4]')}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, workingPlace: {
                                                ...CaracterizacaoEscola.headQuarters.workingPlace,
                                                prisonUnit: e.target.checked ? 1 : 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Outros'
                                    value={"outros"}
                                    checked={CaracterizacaoEscola.headQuarters.workingPlace.otherWP === 1 ? true : false}
                                    name={'workingPlace[5]'}
                                    setValue={setValue('workingPlace[5]', CaracterizacaoEscola.headQuarters.workingPlace.otherWP)}
                                    register={register('workingPlace[5]')}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, workingPlace: {
                                                ...CaracterizacaoEscola.headQuarters.workingPlace,
                                                otherWP: e.target.checked ? 1 : 0
                                            }
                                        }
                                    })} />
                                <Message>{errors.workingPlace?.message}</Message>
                            </Box>
                            <Box style={{ marginTop: 10, display: CaracterizacaoEscola.headQuarters.workingPlace.schoolBuilding === 1 ? 'block' : 'none' }}>
                                <TitleFieldForm>
                                    {getTitleIndex('Forma de ocupação do predio escolar', 'formOccupation')}
                                </TitleFieldForm>
                                <Select

                                    name='formOccupation'
                                    {...register('formOccupation')}
                                    {...setValue('formOccupation', CaracterizacaoEscola.headQuarters.formOccupation ?? 0)}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters,
                                            formOccupation: e.target.value
                                        }
                                    })}
                                >
                                    <Option value={0} disabled hidden>selecione</Option>
                                    <Option value={1}>Próprio</Option>
                                    <Option value={2}>Alugado</Option>
                                    <Option value={3}>Cedido</Option>
                                </Select>
                                <Message>{errors.formOccupation?.message}</Message>
                            </Box>
                            <Box style={{ display: CaracterizacaoEscola.headQuarters.workingPlace.schoolBuilding === 1 ? 'block' : 'none' }}>
                                <TitleFieldForm>
                                    {getTitleIndex('Predio da escola compartilhado com outra escola', 'sharedBuilding')}
                                </TitleFieldForm>
                                <Select

                                    name='sharedBuilding'
                                    {...register('sharedBuilding')}
                                    {...setValue('sharedBuilding', CaracterizacaoEscola.headQuarters.sharedBuilding ?? -1)}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters,
                                            sharedBuilding: e.target.value
                                        }
                                    })}
                                    value={CaracterizacaoEscola.headQuarters.sharedBuilding ?? 0}
                                    disabled={CaracterizacaoEscola.headQuarters.schoolBuilding === 1 ? false : true}
                                >
                                    <Option value={-1} disabled hidden>selecione</Option>
                                    <Option value={0}>Não</Option>
                                    <Option value={1}>Sim</Option>
                                </Select>
                                <Message>{errors.sharedBuilding?.message}</Message>
                            </Box>
                            <Box style={{ display: CaracterizacaoEscola.headQuarters.sharedBuilding === '1' ? 'block' : 'none' }}>
                                <InputResponsive1
                                    title='32a - Código da escola com a qual compartilha'
                                    onChange={(e) => setCaracterizacaoEscola({ ...IdentificacaoEscola.headQuarters, codeSchoolHeadquarters: e.target.value })}
                                />
                            </Box>
                            <Box>
                                <TitleFieldForm>
                                    {getTitleIndex('Fornece água potável para consumo humano', 'haveDrinkingWater')} <Madatory>*</Madatory>
                                </TitleFieldForm>
                                <Select

                                    name="haveDrinkingWater"
                                    {...register('haveDrinkingWater')}
                                    {...setValue('haveDrinkingWater', CaracterizacaoEscola.headQuarters.haveDrinkingWater ?? "DEFAULT")}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters,
                                            haveDrinkingWater: e.target.value
                                        }
                                    })}>
                                    <Option value={-1} disabled hidden>selecione</Option>
                                    <Option value={0}>Não</Option>
                                    <Option value={1}>Sim</Option>
                                </Select>
                                <Message>{errors.haveDrinkingWater?.message}</Message>
                            </Box>
                            <Box>
                                <TitleFieldForm>
                                    {getTitleIndex('abastecimento de água(Assinalar mais de uma opção se for o caso)', 'waterSupply')}<Madatory>*</Madatory>
                                </TitleFieldForm>
                                <Checkbox title='rede pública'
                                    name="waterSupply[0]"
                                    setValue={setValue('waterSupply[0]', CaracterizacaoEscola.headQuarters.waterSupply.publicNetworkWP)}
                                    register={register('waterSupply[0]')}
                                    checked={CaracterizacaoEscola.headQuarters.waterSupply.publicNetworkWP === 1 ? true : false}
                                    disabled={CaracterizacaoEscola.headQuarters.waterSupply.noneWP === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, waterSupply: {
                                                ...CaracterizacaoEscola.headQuarters.waterSupply,
                                                publicNetworkWP: e.target.checked ? 1 : 0,
                                                noneWS: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Poço artesiano'
                                    name="waterSupply[1]"
                                    setValue={setValue('waterSupply[1]', CaracterizacaoEscola.headQuarters.waterSupply.artesianWell)}
                                    register={register('waterSupply[1]')}
                                    checked={CaracterizacaoEscola.headQuarters.waterSupply.artesianWell === 1 ? true : false}
                                    disabled={CaracterizacaoEscola.headQuarters.waterSupply.noneWP === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, waterSupply: {
                                                ...CaracterizacaoEscola.headQuarters.waterSupply,
                                                artesianWell: e.target.checked ? 1 : 0,
                                                noneWS: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Cacimba/cisterna/poço'
                                    name="waterSupply[2]"
                                    setValue={setValue('waterSupply[2]', CaracterizacaoEscola.headQuarters.waterSupply.waterhole)}
                                    register={register('waterSupply[2]')}
                                    checked={CaracterizacaoEscola.headQuarters.waterSupply.waterhole === 1 ? true : false}
                                    disabled={CaracterizacaoEscola.headQuarters.waterSupply.noneWP === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, waterSupply: {
                                                ...CaracterizacaoEscola.headQuarters.waterSupply,
                                                waterhole: e.target.checked ? 1 : 0,
                                                noneWS: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Fonte/rio/igarapé/riacho/córrego'
                                    name="waterSupply[3]"
                                    setValue={setValue('waterSupply[3]', CaracterizacaoEscola.headQuarters.waterSupply.source)}
                                    register={register('waterSupply[3]')}
                                    checked={CaracterizacaoEscola.headQuarters.waterSupply.source === 1 ? true : false}
                                    disabled={CaracterizacaoEscola.headQuarters.waterSupply.noneWP === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, waterSupply: {
                                                ...CaracterizacaoEscola.headQuarters.waterSupply,
                                                source: e.target.checked ? 1 : 0,
                                                noneWS: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Caminhão pipa'
                                    name="waterSupply[4]"
                                    setValue={setValue('waterSupply[4]', CaracterizacaoEscola.headQuarters.waterSupply.waterCar)}
                                    register={register('waterSupply[4]')}
                                    checked={CaracterizacaoEscola.headQuarters.waterSupply.waterCar === 1 ? true : false}
                                    disabled={CaracterizacaoEscola.headQuarters.waterSupply.noneWP === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, waterSupply: {
                                                ...CaracterizacaoEscola.headQuarters.waterSupply,
                                                waterCar: e.target.checked ? 1 : 0,
                                                noneWS: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Não há abastecimento de água'
                                    name="waterSupply[5]"
                                    setValue={setValue('waterSupply[5]', CaracterizacaoEscola.headQuarters.waterSupply.noneWS)}
                                    register={register('waterSupply[5]')}
                                    checked={CaracterizacaoEscola.headQuarters.waterSupply.noneWS === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, waterSupply:
                                                IsNone(CaracterizacaoEscola.headQuarters.waterSupply, 'noneWS')
                                        }
                                    })} />
                                <Message>{errors.waterSupply?.message}</Message>
                            </Box>
                            <Box style={{ marginTop: 10 }}>
                                <TitleFieldForm>
                                    {getTitleIndex('Fonte de energia elétrica(Assinalar mais de uma opção se for o caso)', 'powerSupply')}<Madatory>*</Madatory>

                                </TitleFieldForm>
                                <Checkbox title='rede pública'
                                    name="powerSupply[0]"
                                    setValue={setValue('powerSupply[0]', CaracterizacaoEscola.headQuarters.powerSupply.publicNetworkPS)}
                                    register={register('powerSupply[0]')}
                                    checked={CaracterizacaoEscola.headQuarters.powerSupply.publicNetworkPS === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, powerSupply: {
                                                ...CaracterizacaoEscola.headQuarters.powerSupply,
                                                publicNetworkPS: e.target.checked ? 1 : 0,
                                                nonePS: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Fontes de energia renováveis ou alternativos (generator a biocombustível e/ou biodigestores, eólica, solar, outras)'
                                    name="powerSupply[1]"
                                    setValue={setValue('powerSupply[1]', CaracterizacaoEscola.headQuarters.powerSupply.renewableSource)}
                                    register={register('powerSupply[1]')}
                                    checked={CaracterizacaoEscola.headQuarters.powerSupply.renewableSource === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, powerSupply: {
                                                ...CaracterizacaoEscola.headQuarters.powerSupply,
                                                renewableSource: e.target.checked ? 1 : 0,
                                                nonePS: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Gerador movido a combustivel fóssil'
                                    name="powerSupply[2]"
                                    setValue={setValue('powerSupply[2]', CaracterizacaoEscola.headQuarters.powerSupply.generator)}
                                    register={register('powerSupply[2]')}
                                    checked={CaracterizacaoEscola.headQuarters.powerSupply.generator === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, powerSupply: {
                                                ...CaracterizacaoEscola.headQuarters.powerSupply,
                                                generator: e.target.checked ? 1 : 0,
                                                nonePS: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Não há energia elétrica'
                                    name="powerSupply[3]"
                                    setValue={setValue('powerSupply[3]', CaracterizacaoEscola.headQuarters.powerSupply.nonePS)}
                                    register={register('powerSupply[3]')}
                                    checked={CaracterizacaoEscola.headQuarters.powerSupply.nonePS === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, powerSupply:
                                                IsNone(CaracterizacaoEscola.headQuarters.powerSupply, 'nonePS')
                                        }
                                    })} />
                                <Message>{errors.powerSupply?.message}</Message>
                            </Box>
                            <Box style={{ marginTop: 10 }}>
                                <TitleFieldForm>
                                    {getTitleIndex('Esgotamento Sanitário (Assinalar mais de uma opção se for o caso)', 'sanitarySewage')}<Madatory>*</Madatory>

                                </TitleFieldForm>
                                <Checkbox title='rede pública'
                                    name="sanitarySewage[0]"
                                    setValue={setValue('sanitarySewage[0]', CaracterizacaoEscola.headQuarters.sanitarySewage.publicNetworkSS)}
                                    register={register('sanitarySewage[0]')}
                                    checked={CaracterizacaoEscola.headQuarters.sanitarySewage.publicNetworkSS === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, sanitarySewage: {
                                                ...CaracterizacaoEscola.headQuarters.sanitarySewage,
                                                publicNetworkSS: e.target.checked ? 1 : 0,
                                                noneSS: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Fossa séptica'
                                    name="sanitarySewage[1]"
                                    setValue={setValue('sanitarySewage[1]', CaracterizacaoEscola.headQuarters.sanitarySewage.septicCesspool)}
                                    register={register('sanitarySewage[1]')}
                                    checked={CaracterizacaoEscola.headQuarters.sanitarySewage.septicCesspool === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, sanitarySewage: {
                                                ...CaracterizacaoEscola.headQuarters.sanitarySewage,
                                                septicCesspool: e.target.checked ? 1 : 0,
                                                noneSS: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Fossa rudimentar/comum'
                                    name="sanitarySewage[2]"
                                    setValue={setValue('sanitarySewage[2]', CaracterizacaoEscola.headQuarters.sanitarySewage.commonCesspool)}
                                    register={register('sanitarySewage[2]')}
                                    checked={CaracterizacaoEscola.headQuarters.sanitarySewage.commonCesspool === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, sanitarySewage: {
                                                ...CaracterizacaoEscola.headQuarters.sanitarySewage,
                                                commonCesspool: e.target.checked ? 1 : 0,
                                                noneSS: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Não há esgotamendo sanitário'
                                    name="sanitarySewage[3]"
                                    setValue={setValue('sanitarySewage[3]', CaracterizacaoEscola.headQuarters.sanitarySewage.noneSS)}
                                    register={register('sanitarySewage[3]')}
                                    checked={CaracterizacaoEscola.headQuarters.sanitarySewage.noneSS === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, sanitarySewage:
                                                IsNone(CaracterizacaoEscola.headQuarters.sanitarySewage, 'noneSS')
                                        }
                                    })} />
                                <Message>{errors.sanitarySewage?.message}</Message>
                            </Box>
                            <Box style={{ marginTop: 10 }}>
                                <TitleFieldForm>
                                    {getTitleIndex('Destinação do lixo (Assinalar mais de uma opção se for o caso)', 'garbageDisposal')} <Madatory>*</Madatory>

                                </TitleFieldForm>
                                <Checkbox title='Serviço de coleta'
                                    name="garbageDisposal[0]"
                                    setValue={setValue('garbageDisposal[0]', CaracterizacaoEscola.headQuarters.garbageDisposal.collectionService)}
                                    register={register('garbageDisposal[0]')}
                                    checked={CaracterizacaoEscola.headQuarters.garbageDisposal.collectionService === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, garbageDisposal: {
                                                ...CaracterizacaoEscola.headQuarters.garbageDisposal,
                                                collectionService: e.target.checked ? 1 : 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Queima'
                                    name="garbageDisposal[1]"
                                    setValue={setValue('garbageDisposal[1]', CaracterizacaoEscola.headQuarters.garbageDisposal.burn)}
                                    checked={CaracterizacaoEscola.headQuarters.garbageDisposal.burn === 1 ? true : false}
                                    register={register('garbageDisposal[1]')}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, garbageDisposal: {
                                                ...CaracterizacaoEscola.headQuarters.garbageDisposal,
                                                burn: e.target.checked ? 1 : 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Enterra'
                                    name="garbageDisposal[2]"
                                    setValue={setValue('garbageDisposal[2]', CaracterizacaoEscola.headQuarters.garbageDisposal.bury)}
                                    register={register('garbageDisposal[2]')}
                                    checked={CaracterizacaoEscola.headQuarters.garbageDisposal.bury === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, garbageDisposal: {
                                                ...CaracterizacaoEscola.headQuarters.garbageDisposal,
                                                bury: e.target.checked ? 1 : 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Leva a uma destinação final licenciada pelo poder público'
                                    name="garbageDisposal[3]"
                                    setValue={setValue('garbageDisposal[3]', CaracterizacaoEscola.headQuarters.garbageDisposal.licensedPublicPower)}
                                    register={register('garbageDisposal[3]')}
                                    checked={CaracterizacaoEscola.headQuarters.garbageDisposal.licensedPublicPower === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, garbageDisposal: {
                                                ...CaracterizacaoEscola.headQuarters.garbageDisposal,
                                                licensedPublicPower: e.target.checked ? 1 : 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Descarta em outra área'
                                    name="garbageDisposal[4]"
                                    setValue={setValue('garbageDisposal[4]', CaracterizacaoEscola.headQuarters.garbageDisposal.discardOtherArea)}
                                    register={register('garbageDisposal[4]')}
                                    checked={CaracterizacaoEscola.headQuarters.garbageDisposal.discardOtherArea === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, garbageDisposal: {
                                                ...CaracterizacaoEscola.headQuarters.garbageDisposal,
                                                discardOtherArea: e.target.checked ? 1 : 0
                                            }
                                        }
                                    })} />
                                <Message>{errors.garbageDisposal?.message}</Message>
                            </Box>
                            <Box style={{ marginTop: 10 }}>
                                <TitleFieldForm>
                                    {getTitleIndex('tratamento do lixo (Assinalar mais de uma opção se for o caso)', 'wasteTreatment')} <Madatory>*</Madatory>

                                </TitleFieldForm>
                                <Checkbox title='Separação do lixo/resíduos'
                                    name="wasteTreatment[0]"
                                    setValue={setValue('wasteTreatment[0]', CaracterizacaoEscola.headQuarters.wasteTreatment.wasteSeparation ?? 0)}
                                    register={register("wasteTreatment[0]")}
                                    checked={CaracterizacaoEscola.headQuarters.wasteTreatment.wasteSeparation === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, wasteTreatment: {
                                                ...CaracterizacaoEscola.headQuarters.wasteTreatment,
                                                wasteSeparation: e.target.checked ? 1 : 0,
                                                noneWT: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Reaproveitamento/reutilização'
                                    name="wasteTreatment[1]"
                                    setValue={setValue('wasteTreatment[1]', CaracterizacaoEscola.headQuarters.wasteTreatment.reuse)}
                                    register={register("wasteTreatment[1]")}
                                    checked={CaracterizacaoEscola.headQuarters.wasteTreatment.reuse === 1 ? true : false}
                                    disabled={CaracterizacaoEscola.headQuarters.wasteTreatment.wasteSeparation === 1 ? false : true}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, wasteTreatment: {
                                                ...CaracterizacaoEscola.headQuarters.wasteTreatment,
                                                reuse: e.target.checked ? 1 : 0,
                                                noneWT: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Reciclagem'
                                    name="wasteTreatment[2]"
                                    setValue={setValue('wasteTreatment[2]', CaracterizacaoEscola.headQuarters.wasteTreatment.recycling)}
                                    register={register("wasteTreatment[2]")}
                                    checked={CaracterizacaoEscola.headQuarters.wasteTreatment.recycling === 1 ? true : false}
                                    disabled={CaracterizacaoEscola.headQuarters.wasteTreatment.wasteSeparation === 1 ? false : true}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, wasteTreatment: {
                                                ...CaracterizacaoEscola.headQuarters.wasteTreatment,
                                                recycling: e.target.checked ? 1 : 0,
                                                noneWT: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Não faz tratamento'
                                    name="wasteTreatment[3]"
                                    setValue={setValue('wasteTreatment[3]', CaracterizacaoEscola.headQuarters.wasteTreatment.noneWT)}
                                    register={register("wasteTreatment[3]")}
                                    checked={CaracterizacaoEscola.headQuarters.wasteTreatment.noneWT === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, wasteTreatment:
                                                IsNone(CaracterizacaoEscola.headQuarters.wasteTreatment, 'noneWT')
                                        }
                                    })} />
                                <Message>{errors.wasteTreatment?.message}</Message>
                            </Box>
                            <Box style={{ marginTop: 10 }}>
                                <TitleFieldForm>
                                    {getTitleIndex('Dependências físicas existentes na escola ', 'existingPhysicalDependencies')} <Madatory>*</Madatory>
                                </TitleFieldForm>
                                <Message>{errors.existingPhysicalDependencies?.message}</Message>
                                <Checkbox title='Almoxarifado'
                                    name='existingPhysicalDependencies[0]'
                                    setValue={setValue('existingPhysicalDependencies[0]', CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.warehouse)}
                                    register={register('existingPhysicalDependencies[0]')}
                                    checked={CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.warehouse === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, existingPhysicalDependencies: {
                                                ...CaracterizacaoEscola.headQuarters.existingPhysicalDependencies,
                                                warehouse: e.target.checked ? 1 : 0,
                                                nonePD: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Área de vegetação ou gramado'
                                    name='existingPhysicalDependencies[1]'
                                    setValue={setValue('existingPhysicalDependencies[1]', CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.greenArea)}
                                    register={register('existingPhysicalDependencies[1]')}
                                    checked={CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.greenArea === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, existingPhysicalDependencies: {
                                                ...CaracterizacaoEscola.headQuarters.existingPhysicalDependencies,
                                                greenArea: e.target.checked ? 1 : 0,
                                                nonePD: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Auditório'
                                    name='existingPhysicalDependencies[2]'
                                    setValue={setValue('existingPhysicalDependencies[2]', CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.auditorium)}
                                    register={register('existingPhysicalDependencies[2]')}
                                    checked={CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.auditorium === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, existingPhysicalDependencies: {
                                                ...CaracterizacaoEscola.headQuarters.existingPhysicalDependencies,
                                                auditorium: e.target.checked ? 1 : 0,
                                                nonePD: 0
                                            }
                                        }
                                    })} />
                                {/*deve ver preeenchido quando algum dos banheiro for marcado*/}
                                <Checkbox title='Banheiro'
                                    name='existingPhysicalDependencies[3]'
                                    setValue={setValue('existingPhysicalDependencies[3]', CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.bathroom)}
                                    register={register('existingPhysicalDependencies[3]')}
                                    checked={CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.bathroom === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, existingPhysicalDependencies: {
                                                ...CaracterizacaoEscola.headQuarters.existingPhysicalDependencies,
                                                bathroom: e.target.checked ? 1 : 0,
                                                nonePD: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Banheiro acessível, adequado ao uso de pessoas com deficiência ou mobilidade reduzida'
                                    name='existingPhysicalDependencies[4]'
                                    setValue={setValue('existingPhysicalDependencies[4]', CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.accessibleBathroom)}
                                    register={register('existingPhysicalDependencies[4]')}
                                    checked={CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.accessibleBathroom === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, existingPhysicalDependencies: {
                                                ...CaracterizacaoEscola.headQuarters.existingPhysicalDependencies,
                                                accessibleBathroom: e.target.checked ? 1 : 0,
                                                nonePD: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Banheiro adequando à educação infantil'
                                    name='existingPhysicalDependencies[5]'
                                    setValue={setValue('existingPhysicalDependencies[5]', CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.childEducationBathroom)}
                                    register={register('existingPhysicalDependencies[5]')}
                                    checked={CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.childEducationBathroom === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, existingPhysicalDependencies: {
                                                ...CaracterizacaoEscola.headQuarters.existingPhysicalDependencies,
                                                childEducationBathroom: e.target.checked ? 1 : 0,
                                                nonePD: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Banheiro exclusivo para os funcionários'
                                    name='existingPhysicalDependencies[6]'
                                    setValue={setValue('existingPhysicalDependencies[6]', CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.exclusiveBathroomEmployees)}
                                    register={register('existingPhysicalDependencies[6]')}
                                    checked={CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.exclusiveBathroomEmployees === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, existingPhysicalDependencies: {
                                                ...CaracterizacaoEscola.headQuarters.existingPhysicalDependencies,
                                                exclusiveBathroomEmployees: e.target.checked ? 1 : 0,
                                                nonePD: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Banheiro ou vestiários com chuveiro'
                                    name='existingPhysicalDependencies[7]'
                                    setValue={setValue('existingPhysicalDependencies[7]', CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.bathroomShower)}
                                    register={register('existingPhysicalDependencies[7]')}
                                    checked={CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.bathroomShower === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, existingPhysicalDependencies: {
                                                ...CaracterizacaoEscola.headQuarters.existingPhysicalDependencies,
                                                bathroomShower: e.target.checked ? 1 : 0,
                                                nonePD: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Biblioteca'
                                    name='existingPhysicalDependencies[8]'
                                    setValue={setValue('existingPhysicalDependencies[8]', CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.library)}
                                    register={register('existingPhysicalDependencies[8]')}
                                    checked={CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.library === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, existingPhysicalDependencies: {
                                                ...CaracterizacaoEscola.headQuarters.existingPhysicalDependencies,
                                                library: e.target.checked ? 1 : 0,
                                                nonePD: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Cozinha'
                                    name='existingPhysicalDependencies[9]'
                                    setValue={setValue('existingPhysicalDependencies[9]', CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.kitchen)}
                                    register={register('existingPhysicalDependencies[9]')}
                                    checked={CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.kitchen === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, existingPhysicalDependencies: {
                                                ...CaracterizacaoEscola.headQuarters.existingPhysicalDependencies,
                                                kitchen: e.target.checked ? 1 : 0,
                                                nonePD: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Dispensa'
                                    name='existingPhysicalDependencies[10]'
                                    setValue={setValue('existingPhysicalDependencies[10]', CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.pantry)}
                                    register={register('existingPhysicalDependencies[10]')}
                                    checked={CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.pantry === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, existingPhysicalDependencies: {
                                                ...CaracterizacaoEscola.headQuarters.existingPhysicalDependencies,
                                                pantry: e.target.checked ? 1 : 0,
                                                nonePD: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Dormitório de aluno(a)'
                                    name='existingPhysicalDependencies[11]'
                                    setValue={setValue('existingPhysicalDependencies[11]', CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.studentDormitory)}
                                    register={register('existingPhysicalDependencies[11]')}
                                    checked={CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.studentDormitory === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, existingPhysicalDependencies: {
                                                ...CaracterizacaoEscola.headQuarters.existingPhysicalDependencies,
                                                studentDormitory: e.target.checked ? 1 : 0,
                                                nonePD: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Dormitório de professor(a)'
                                    name='existingPhysicalDependencies[12]'
                                    setValue={setValue('existingPhysicalDependencies[12]', CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.teacherDormitory)}
                                    register={register('existingPhysicalDependencies[12]')}
                                    checked={CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.teacherDormitory === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, existingPhysicalDependencies: {
                                                ...CaracterizacaoEscola.headQuarters.existingPhysicalDependencies,
                                                teacherDormitory: e.target.checked ? 1 : 0,
                                                nonePD: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Laboratório de ciências'
                                    name='existingPhysicalDependencies[13]'
                                    setValue={setValue('existingPhysicalDependencies[13]', CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.scienceLab)}
                                    register={register('existingPhysicalDependencies[13]')}
                                    checked={CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.scienceLab === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, existingPhysicalDependencies: {
                                                ...CaracterizacaoEscola.headQuarters.existingPhysicalDependencies,
                                                scienceLab: e.target.checked ? 1 : 0,
                                                nonePD: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Laboratório de informática'
                                    name='existingPhysicalDependencies[14]'
                                    setValue={setValue('existingPhysicalDependencies[14]', CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.computerLab)}
                                    register={register('existingPhysicalDependencies[14]')}
                                    checked={CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.computerLab === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, existingPhysicalDependencies: {
                                                ...CaracterizacaoEscola.headQuarters.existingPhysicalDependencies,
                                                computerLab: e.target.checked ? 1 : 0,
                                                nonePD: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Laboratório especifico para a educação profissional'
                                    name='existingPhysicalDependencies[15]'
                                    setValue={setValue('existingPhysicalDependencies[15]', CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.professionalEducationLab)}
                                    register={register('existingPhysicalDependencies[15]')}
                                    checked={CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.professionalEducationLab === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, existingPhysicalDependencies: {
                                                ...CaracterizacaoEscola.headQuarters.existingPhysicalDependencies,
                                                professionalEducationLab: e.target.checked ? 1 : 0,
                                                nonePD: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Parque infantil'
                                    name='existingPhysicalDependencies[16]'
                                    setValue={setValue('existingPhysicalDependencies[16]', CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.playground)}
                                    register={register('existingPhysicalDependencies[16]')}
                                    checked={CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.playground === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, existingPhysicalDependencies: {
                                                ...CaracterizacaoEscola.headQuarters.existingPhysicalDependencies,
                                                playground: e.target.checked ? 1 : 0,
                                                nonePD: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Pátio coberto'
                                    name='existingPhysicalDependencies[17]'
                                    setValue={setValue('existingPhysicalDependencies[17]', CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.coveredPatio)}
                                    register={register('existingPhysicalDependencies[17]')}
                                    checked={CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.coveredPatio === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, existingPhysicalDependencies: {
                                                ...CaracterizacaoEscola.headQuarters.existingPhysicalDependencies,
                                                coveredPatio: e.target.checked ? 1 : 0,
                                                nonePD: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Pátio descoberto'
                                    name='existingPhysicalDependencies[18]'
                                    setValue={setValue('existingPhysicalDependencies[18]', CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.uncoveredPatio)}
                                    register={register('existingPhysicalDependencies[18]')}
                                    checked={CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.uncoveredPatio === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, existingPhysicalDependencies: {
                                                ...CaracterizacaoEscola.headQuarters.existingPhysicalDependencies,
                                                uncoveredPatio: e.target.checked ? 1 : 0,
                                                nonePD: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Piscina'
                                    name='existingPhysicalDependencies[19]'
                                    setValue={setValue('existingPhysicalDependencies[19]', CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.pool)}
                                    register={register('existingPhysicalDependencies[19]')}
                                    checked={CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.pool === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, existingPhysicalDependencies: {
                                                ...CaracterizacaoEscola.headQuarters.existingPhysicalDependencies,
                                                pool: e.target.checked ? 1 : 0,
                                                nonePD: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Quadra de Esporte coberta'
                                    name='existingPhysicalDependencies[20]'
                                    setValue={setValue('existingPhysicalDependencies[20]', CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.indoorSportsCourt)}
                                    register={register('existingPhysicalDependencies[20]')}
                                    checked={CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.indoorSportsCourt === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, existingPhysicalDependencies: {
                                                ...CaracterizacaoEscola.headQuarters.existingPhysicalDependencies,
                                                indoorSportsCourt: e.target.checked ? 1 : 0,
                                                nonePD: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Quadra de Esporte descoberta'
                                    name='existingPhysicalDependencies[21]'
                                    setValue={setValue('existingPhysicalDependencies[21]', CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.outdoorSportsCourt)}
                                    register={register('existingPhysicalDependencies[21]')}
                                    checked={CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.outdoorSportsCourt === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, existingPhysicalDependencies: {
                                                ...CaracterizacaoEscola.headQuarters.existingPhysicalDependencies,
                                                outdoorSportsCourt: e.target.checked ? 1 : 0,
                                                nonePD: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Refeitório'
                                    name='existingPhysicalDependencies[22]'
                                    setValue={setValue('existingPhysicalDependencies[22]', CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.refectory)}
                                    register={register('existingPhysicalDependencies[22]')}
                                    checked={CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.refectory === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, existingPhysicalDependencies: {
                                                ...CaracterizacaoEscola.headQuarters.existingPhysicalDependencies,
                                                refectory: e.target.checked ? 1 : 0,
                                                nonePD: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Sala de repouso para aluno(a)'
                                    name='existingPhysicalDependencies[23]'
                                    setValue={setValue('existingPhysicalDependencies[23]', CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.studentRestRoom)}
                                    register={register('existingPhysicalDependencies[23]')}
                                    checked={CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.studentRestRoom === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, existingPhysicalDependencies: {
                                                ...CaracterizacaoEscola.headQuarters.existingPhysicalDependencies,
                                                studentRestRoom: e.target.checked ? 1 : 0,
                                                nonePD: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Sala/ateliê de artes'
                                    name='existingPhysicalDependencies[24]'
                                    setValue={setValue('existingPhysicalDependencies[24]', CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.artRoom)}
                                    register={register('existingPhysicalDependencies[24]')}
                                    checked={CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.artRoom === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, existingPhysicalDependencies: {
                                                ...CaracterizacaoEscola.headQuarters.existingPhysicalDependencies,
                                                artRoom: e.target.checked ? 1 : 0,
                                                nonePD: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Sala de música/coral'
                                    name='existingPhysicalDependencies[25]'
                                    setValue={setValue('existingPhysicalDependencies[25]', CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.musicRoom)}
                                    register={register('existingPhysicalDependencies[25]')}
                                    checked={CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.musicRoom === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, existingPhysicalDependencies: {
                                                ...CaracterizacaoEscola.headQuarters.existingPhysicalDependencies,
                                                musicRoom: e.target.checked ? 1 : 0,
                                                nonePD: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Sala/estúdio de dança'
                                    name='existingPhysicalDependencies[26]'
                                    setValue={setValue('existingPhysicalDependencies[26]', CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.danceRoom)}
                                    register={register('existingPhysicalDependencies[26]')}
                                    checked={CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.danceRoom === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, existingPhysicalDependencies: {
                                                ...CaracterizacaoEscola.headQuarters.existingPhysicalDependencies,
                                                danceRoom: e.target.checked ? 1 : 0,
                                                nonePD: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Sala multiuso (música, dança e artes)'
                                    name='existingPhysicalDependencies[27]'
                                    setValue={setValue('existingPhysicalDependencies[27]', CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.multipurposeRoom)}
                                    register={register('existingPhysicalDependencies[27]')}
                                    checked={CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.multipurposeRoom === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, existingPhysicalDependencies: {
                                                ...CaracterizacaoEscola.headQuarters.existingPhysicalDependencies,
                                                multipurposeRoom: e.target.checked ? 1 : 0,
                                                nonePD: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Terreirão (área para prática desportiva e recreação sem cobertura, sem piso e sem edificações)'
                                    name='existingPhysicalDependencies[28]'
                                    setValue={setValue('existingPhysicalDependencies[28]', CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.bigLand)}
                                    register={register('existingPhysicalDependencies[28]')}
                                    checked={CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.bigLand === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, existingPhysicalDependencies: {
                                                ...CaracterizacaoEscola.headQuarters.existingPhysicalDependencies,
                                                bigLand: e.target.checked ? 1 : 0,
                                                nonePD: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Viveiro/ criação de animais'
                                    name='existingPhysicalDependencies[29]'
                                    setValue={setValue('existingPhysicalDependencies[29]', CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.animalNursery)}
                                    register={register('existingPhysicalDependencies[29]')}
                                    checked={CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.animalNursery === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, existingPhysicalDependencies: {
                                                ...CaracterizacaoEscola.headQuarters.existingPhysicalDependencies,
                                                animalNursery: e.target.checked ? 1 : 0,
                                                nonePD: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Sala de diretoria '
                                    name='existingPhysicalDependencies[30]'
                                    setValue={setValue('existingPhysicalDependencies[30]', CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.directorOffice)}
                                    register={register('existingPhysicalDependencies[30]')}
                                    checked={CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.directorOffice === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, existingPhysicalDependencies: {
                                                ...CaracterizacaoEscola.headQuarters.existingPhysicalDependencies,
                                                directorOffice: e.target.checked ? 1 : 0,
                                                nonePD: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Sala de leitura'
                                    name='existingPhysicalDependencies[31]'
                                    setValue={setValue('existingPhysicalDependencies[31]', CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.readingRoom)}
                                    register={register('existingPhysicalDependencies[31]')}
                                    checked={CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.readingRoom === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, existingPhysicalDependencies: {
                                                ...CaracterizacaoEscola.headQuarters.existingPhysicalDependencies,
                                                readingRoom: e.target.checked ? 1 : 0,
                                                nonePD: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Sala de professores'
                                    name='existingPhysicalDependencies[32]'
                                    setValue={setValue('existingPhysicalDependencies[32]', CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.teachersRoom)}
                                    register={register('existingPhysicalDependencies[32]')}
                                    checked={CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.teachersRoom === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, existingPhysicalDependencies: {
                                                ...CaracterizacaoEscola.headQuarters.existingPhysicalDependencies,
                                                teachersRoom: e.target.checked ? 1 : 0,
                                                nonePD: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Sala de recursos multifuncionais para atendimento educacional especializado (AEE)'
                                    name='existingPhysicalDependencies[33]'
                                    setValue={setValue('existingPhysicalDependencies[33]', CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.aeeroom)}
                                    register={register('existingPhysicalDependencies[33]')}
                                    checked={CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.aeeroom === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, existingPhysicalDependencies: {
                                                ...CaracterizacaoEscola.headQuarters.existingPhysicalDependencies,
                                                aeeroom: e.target.checked ? 1 : 0,
                                                nonePD: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Sala de secretaria'
                                    name='existingPhysicalDependencies[34]'
                                    setValue={setValue('existingPhysicalDependencies[34]', CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.secretaryRoom)}
                                    register={register('existingPhysicalDependencies[34]')}
                                    checked={CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.secretaryRoom === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, existingPhysicalDependencies: {
                                                ...CaracterizacaoEscola.headQuarters.existingPhysicalDependencies,
                                                secretaryRoom: e.target.checked ? 1 : 0,
                                                nonePD: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Sala de oficinas da educação profissional'
                                    name='existingPhysicalDependencies[35]'
                                    setValue={setValue('existingPhysicalDependencies[35]', CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.professionalEducationRoom)}
                                    register={register('existingPhysicalDependencies[35]')}
                                    checked={CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.professionalEducationRoom === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, existingPhysicalDependencies: {
                                                ...CaracterizacaoEscola.headQuarters.existingPhysicalDependencies,
                                                professionalEducationRoom: e.target.checked ? 1 : 0,
                                                nonePD: 0
                                            }
                                        }
                                    })} />

                                <Checkbox title='Estúdio de gravação e edição'
                                    name='existingPhysicalDependencies[36]'
                                    setValue={setValue('existingPhysicalDependencies[36]', CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.recordingEditingStudio)}
                                    register={register('existingPhysicalDependencies[36]')}
                                    checked={CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.recordingEditingStudio === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, existingPhysicalDependencies: {
                                                ...CaracterizacaoEscola.headQuarters.existingPhysicalDependencies,
                                                recordingEditingStudio: e.target.checked ? 1 : 0,
                                                nonePD: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Área de horta, plantio e/ou produção agrícola'
                                    name='existingPhysicalDependencies[37]'
                                    setValue={setValue('existingPhysicalDependencies[37]', CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.agriculturalProduction)}
                                    register={register('existingPhysicalDependencies[37]')}
                                    checked={CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.agriculturalProduction === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters.existingPhysicalDependencies,
                                            agriculturalProduction: e.target.checked ? 1 : 0,
                                            nonePD: 0
                                        }
                                    })} />
                                <Checkbox title='Nenhuma das dependências relacionadas'
                                    name='existingPhysicalDependencies[38]'
                                    setValue={setValue('existingPhysicalDependencies[38]', CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.nonePD)}
                                    register={register('existingPhysicalDependencies[38]')}
                                    checked={CaracterizacaoEscola.headQuarters.existingPhysicalDependencies.nonePD === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, existingPhysicalDependencies:
                                                IsNone(CaracterizacaoEscola.headQuarters.existingPhysicalDependencies, 'nonePD')
                                        }
                                    })} />
                            </Box>
                            <Box style={{ marginTop: 10 }}>
                                <TitleFieldForm>
                                    {getTitleIndex('Recursos de acessibilidade para pessoas com deficiencias ou mobilidade reduzida nas vias de circulação interna da escola', 'accessibilityFeatures')}<Madatory>*</Madatory>
                                </TitleFieldForm>
                                <Message>{errors.accessibilityFeatures?.message}</Message>
                                <Checkbox title='Corrimão e guarda-corpos'
                                    name='accessibilityFeatures[0]'
                                    setValue={setValue('accessibilityFeatures[0]', CaracterizacaoEscola.headQuarters.accessibilityFeatures.handrailGuardrail)}
                                    register={register('accessibilityFeatures[0]')}
                                    checked={CaracterizacaoEscola.headQuarters.accessibilityFeatures.handrailGuardrail === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, accessibilityFeatures: {
                                                ...CaracterizacaoEscola.headQuarters.accessibilityFeatures,
                                                handrailGuardrail: e.target.checked ? 1 : 0,
                                                noneAF: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Elevador'
                                    name='accessibilityFeatures[1]'
                                    setValue={setValue('accessibilityFeatures[1]', CaracterizacaoEscola.headQuarters.accessibilityFeatures.elevator)}
                                    register={register('accessibilityFeatures[1]')}
                                    checked={CaracterizacaoEscola.headQuarters.accessibilityFeatures.elevator === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, accessibilityFeatures: {
                                                ...CaracterizacaoEscola.headQuarters.accessibilityFeatures,
                                                elevator: e.target.checked ? 1 : 0,
                                                noneAF: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Pisos táteis'
                                    name='accessibilityFeatures[2]'
                                    setValue={setValue('accessibilityFeatures[2]', CaracterizacaoEscola.headQuarters.accessibilityFeatures.tactileFloors)}
                                    register={register('accessibilityFeatures[2]')}
                                    checked={CaracterizacaoEscola.headQuarters.accessibilityFeatures.tactileFloors === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, accessibilityFeatures: {
                                                ...CaracterizacaoEscola.headQuarters.accessibilityFeatures,
                                                tactileFloors: e.target.checked ? 1 : 0,
                                                noneAF: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Portas com vão livre de no mínino 80 cm'
                                    name='accessibilityFeatures[3]'
                                    setValue={setValue('accessibilityFeatures[3]', CaracterizacaoEscola.headQuarters.accessibilityFeatures.freeDoors80cm)}
                                    register={register('accessibilityFeatures[3]')}
                                    checked={CaracterizacaoEscola.headQuarters.accessibilityFeatures.freeDoors80cm === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, accessibilityFeatures: {
                                                ...CaracterizacaoEscola.headQuarters.accessibilityFeatures,
                                                freeDoors80cm: e.target.checked ? 1 : 0,
                                                noneAF: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Rampas'
                                    name='accessibilityFeatures[4]'
                                    setValue={setValue('accessibilityFeatures[4]', CaracterizacaoEscola.headQuarters.accessibilityFeatures.ramps)}
                                    register={register('accessibilityFeatures[4]')}
                                    checked={CaracterizacaoEscola.headQuarters.accessibilityFeatures.ramps === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, accessibilityFeatures: {
                                                ...CaracterizacaoEscola.headQuarters.accessibilityFeatures,
                                                ramps: e.target.checked ? 1 : 0,
                                                noneAF: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Sinalização sonora'
                                    name='accessibilityFeatures[5]'
                                    setValue={setValue('accessibilityFeatures[5]', CaracterizacaoEscola.headQuarters.accessibilityFeatures.soundSignaling)}
                                    register={register('accessibilityFeatures[5]')}
                                    checked={CaracterizacaoEscola.headQuarters.accessibilityFeatures.soundSignaling === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, accessibilityFeatures: {
                                                ...CaracterizacaoEscola.headQuarters.accessibilityFeatures,
                                                soundSignaling: e.target.checked ? 1 : 0,
                                                noneAF: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Sinalização tátil'
                                    name='accessibilityFeatures[6]'
                                    setValue={setValue('accessibilityFeatures[6]', CaracterizacaoEscola.headQuarters.accessibilityFeatures.tactileSignaling)}
                                    register={register('accessibilityFeatures[6]')}
                                    checked={CaracterizacaoEscola.headQuarters.accessibilityFeatures.tactileSignaling === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, accessibilityFeatures: {
                                                ...CaracterizacaoEscola.headQuarters.accessibilityFeatures,
                                                tactileSignaling: e.target.checked ? 1 : 0,
                                                noneAF: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Sinalização visual (piso/parede)'
                                    name='accessibitityFeature[7]'
                                    setValue={setValue('accessibilityFeatures[7]', CaracterizacaoEscola.headQuarters.accessibilityFeatures.visualSignage)}
                                    register={register('accessibilityFeatures[7]')}
                                    checked={CaracterizacaoEscola.headQuarters.accessibilityFeatures.visualSignage === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, accessibilityFeatures: {
                                                ...CaracterizacaoEscola.headQuarters.accessibilityFeatures,
                                                visualSignage: e.target.checked ? 1 : 0,
                                                noneAF: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Sinalização/alarme luminoso'
                                    name='accessibilityFeatures[8]'
                                    setValue={setValue('accessibilityFeatures[8]', CaracterizacaoEscola.headQuarters.accessibilityFeatures.lightAlarm)}
                                    register={register('accessibilityFeatures[8]')}
                                    checked={CaracterizacaoEscola.headQuarters.accessibilityFeatures.lightAlarm === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters.accessibilityFeatures,
                                            lightAlarm: e.target.checked ? 1 : 0,
                                            noneAF: 0
                                        }
                                    })} />
                                <Checkbox title='Nenhum dos recursos de acessibilidade listados'
                                    name='accessibilityFeatures[9]'
                                    setValue={setValue('accessibilityFeatures[9]', CaracterizacaoEscola.headQuarters.accessibilityFeatures.noneAF)}
                                    register={register('accessibilityFeatures[9]')}
                                    checked={CaracterizacaoEscola.headQuarters.accessibilityFeatures.noneAF === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters, accessibilityFeatures:
                                                IsNone(CaracterizacaoEscola.headQuarters.accessibilityFeatures, 'noneAF')
                                        }
                                    })} />

                            </Box>
                            <Box style={{ marginTop: 10 }}>
                                <TitleFieldForm> {getTitleIndex('Número de salas de aula utilizadas na escola', 'numberIndoorRooms')}  <Madatory>*</Madatory></TitleFieldForm>
                                <InputResponsive1

                                    name='numberIndoorRooms'
                                    {...setValue('numberIndoorRooms', CaracterizacaoEscola.headQuarters.numberIndoorRooms ?? 0)}
                                    value={CaracterizacaoEscola.headQuarters.numberIndoorRooms}
                                    register={register('numberIndoorRooms')}
                                    error={errors.numberIndoorRooms?.message}
                                    title="Quantidade de salas de aula utilizadas pela escola dentro do prédio escolar"
                                    disabled={CaracterizacaoEscola.headQuarters.workingPlace.schoolBuilding === 1 ? false : true}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters,
                                            numberIndoorRooms: e.target.value
                                        }
                                    })} />
                                <InputResponsive1 title="Quantidade de salas de aula utilizadas pela escola fora do prédio escolar"
                                    name='numberRoomsOutside'
                                    register={register('numberRoomsOutside')}
                                    {...setValue('numberRoomsOutside', CaracterizacaoEscola.headQuarters.numberRoomsOutside ?? 0)}
                                    value={CaracterizacaoEscola.headQuarters.numberRoomsOutside}
                                    erro={errors.numberRoomsOutside?.message}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters,
                                            numberRoomsOutside: e.target.value
                                        }
                                    })} />
                                <InputResponsive1 style={{ display: CaracterizacaoEscola.headQuarters.numberIndoorRooms > 0 || CaracterizacaoEscola.headQuarters.numberRoomsOutside > 0 ? 'flex' : 'None' }} title="Quantidade de salas de aula com Cantinho da Leitura para a Educação Infantil e o Ensino fundamental (Anos iniciais)"
                                    name='numberChildEducationRooms'
                                    register={register('numberChildEducationRooms')}
                                    {...setValue('numberChildEducationRooms', CaracterizacaoEscola.headQuarters.numberChildEducationRooms ?? 0)}
                                    value={CaracterizacaoEscola.headQuarters.numberChildEducationRooms}
                                    erro={errors.numberChildEducationRooms?.message}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters,
                                            numberChildEducationRooms: e.target.value
                                        }
                                    })} />

                                <TitleFieldForm> {getTitleIndex('Condições das salas de aulas utilizada pela escola', 'numberAirconditionedRooms')}</TitleFieldForm>

                                <InputResponsive1 title="Quantidade de salas de aula climatizadas (com ar-condicionado, aquecedor ou climatizador)"
                                    name='numberAirconditionedRooms'
                                    register={register('numberAirconditionedRooms')}
                                    {...setValue('numberAirconditionedRooms', CaracterizacaoEscola.headQuarters.numberAirconditionedRooms ?? 0)}
                                    value={CaracterizacaoEscola.headQuarters.numberAirconditionedRooms}
                                    erro={errors.numberAirconditionedRooms?.message}
                                    disabled={Number(CaracterizacaoEscola.headQuarters.numberIndoorRooms) +
                                        Number(CaracterizacaoEscola.headQuarters.numberRoomsOutside) >= 1 ? false : true}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters,
                                            numberAirconditionedRooms: e.target.value
                                        }
                                    })} />
                                <InputResponsive1 title="Quantidade de salas de aula com acessibilidade para pessoas com deficiência ou mobilidade reduzida"
                                    name='numberAccessibleRooms'
                                    {...setValue('numberAccessibleRooms', CaracterizacaoEscola.headQuarters.numberAccessibleRooms ?? 0)}
                                    value={CaracterizacaoEscola.headQuarters.numberAccessibleRooms}
                                    register={register('numberAccessibleRooms')}
                                    erro={errors.numberAccessibleRooms?.message}
                                    disabled={Number(CaracterizacaoEscola.headQuarters.numberIndoorRooms) +
                                        Number(CaracterizacaoEscola.headQuarters.numberRoomsOutside) >= 1 ? false : true}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, headQuarters: {
                                            ...CaracterizacaoEscola.headQuarters,
                                            numberAccessibleRooms: e.target.value
                                        }
                                    })} />
                            </Box>

                        </FormContent>
                        <TextLabel>Equipamentos</TextLabel>
                        <FormContent style={{ marginTop: 20 }}>


                            <Box style={{ marginTop: 10 }}>
                                <TitleFieldForm>
                                    {getTitleIndex('Equipamentos existentes na escola para o uso técnico e administrativo', 'administrativeTechnicians')} <Madatory>*</Madatory>

                                </TitleFieldForm>
                                <Checkbox title='Antena parabólica'
                                    name='administrativeTechnicians[0]'
                                    setValue={setValue('administrativeTechnicians[0]', CaracterizacaoEscola.equipmentResource.administrativeTechnicians.antenna)}
                                    register={register("administrativeTechnicians[0]")}
                                    checked={CaracterizacaoEscola.equipmentResource.administrativeTechnicians.antenna === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, equipmentResource: {
                                            ...CaracterizacaoEscola.equipmentResource, administrativeTechnicians: {
                                                ...CaracterizacaoEscola.equipmentResource.administrativeTechnicians,
                                                antenna: e.target.checked ? 1 : 0,
                                                noneAT: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Computadores'
                                    name='administrativeTechnicians[1]'
                                    setValue={setValue('administrativeTechnicians[1]', CaracterizacaoEscola.equipmentResource.administrativeTechnicians.computer)}
                                    register={register("administrativeTechnicians[1]")}
                                    checked={CaracterizacaoEscola.equipmentResource.administrativeTechnicians.computer === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, equipmentResource: {
                                            ...CaracterizacaoEscola.equipmentResource, administrativeTechnicians: {
                                                ...CaracterizacaoEscola.equipmentResource.administrativeTechnicians,
                                                computer: e.target.checked ? 1 : 0,
                                                noneAT: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Copiadora'
                                    name='administrativeTechnicians[2]'
                                    setValue={setValue('administrativeTechnicians[2]', CaracterizacaoEscola.equipmentResource.administrativeTechnicians.copyMachine)}
                                    register={register("administrativeTechnicians[2]")}
                                    checked={CaracterizacaoEscola.equipmentResource.administrativeTechnicians.copyMachine === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, equipmentResource: {
                                            ...CaracterizacaoEscola.equipmentResource, administrativeTechnicians: {
                                                ...CaracterizacaoEscola.equipmentResource.administrativeTechnicians,
                                                copyMachine: e.target.checked ? 1 : 0,
                                                noneAT: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Impressora'
                                    name='administrativeTechnicians[3]'
                                    setValue={setValue('administrativeTechnicians[3]', CaracterizacaoEscola.equipmentResource.administrativeTechnicians.printer)}
                                    register={register("administrativeTechnicians[3]")}
                                    checked={CaracterizacaoEscola.equipmentResource.administrativeTechnicians.printer === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, equipmentResource: {
                                            ...CaracterizacaoEscola.equipmentResource, administrativeTechnicians: {
                                                ...CaracterizacaoEscola.equipmentResource.administrativeTechnicians,
                                                printer: e.target.checked ? 1 : 0,
                                                noneAT: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Impressora multifuncional'
                                    name='administrativeTechnicians[4]'
                                    setValue={setValue('administrativeTechnicians[4]', CaracterizacaoEscola.equipmentResource.administrativeTechnicians.multifunction)}
                                    register={register("administrativeTechnicians[4]")}
                                    checked={CaracterizacaoEscola.equipmentResource.administrativeTechnicians.multifunction === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, equipmentResource: {
                                            ...CaracterizacaoEscola.equipmentResource, administrativeTechnicians: {
                                                ...CaracterizacaoEscola.equipmentResource.administrativeTechnicians,
                                                multifunction: e.target.checked ? 1 : 0,
                                                noneAT: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Scanner'
                                    name='administrativeTechnicians[5]'
                                    setValue={setValue('administrativeTechnicians[5]', CaracterizacaoEscola.equipmentResource.administrativeTechnicians.scanner ?? 0)}
                                    register={register("administrativeTechnicians[5]")}
                                    checked={CaracterizacaoEscola.equipmentResource.administrativeTechnicians.scanner === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, equipmentResource: {
                                            ...CaracterizacaoEscola.equipmentResource, administrativeTechnicians: {
                                                ...CaracterizacaoEscola.equipmentResource.administrativeTechnicians,
                                                scanner: e.target.checked ? 1 : 0,
                                                noneAT: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Nenhum dos equipamento listados'
                                    name='administrativeTechnicians[6]'
                                    setValue={setValue('administrativeTechnicians[6]', CaracterizacaoEscola.equipmentResource.administrativeTechnicians.noneAT ?? 0)}
                                    register={register("administrativeTechnicians[6]")}
                                    checked={CaracterizacaoEscola.equipmentResource.administrativeTechnicians.noneAT === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, equipmentResource: {
                                            ...CaracterizacaoEscola.equipmentResource,
                                            administrativeTechnicians: IsNone(CaracterizacaoEscola.equipmentResource.administrativeTechnicians, 'noneAT')
                                        }
                                    })} />
                                <Message>{errors.administrativeTechnicians?.message}</Message>
                            </Box>
                            <Box style={{ marginTop: 10 }}>
                                <TitleFieldForm> {getTitleIndex('Quantidade de equipamento para o processo de ensino aprendizagem', 'teachingLearning')}  <Madatory>*</Madatory></TitleFieldForm>
                                <Message>{errors.teachingLearning?.message}</Message>
                                <Box2Items>
                                    <Box50 style={{ marginRight: 20 }}>
                                        <label className='LabelInput'>Aparelhos de televisão</label>
                                        <input className="input"
                                            color='red'
                                            name='teachingLearning[0]'
                                            {...setValue('teachingLearning[0]', CaracterizacaoEscola.equipmentResource.teachingLearning.tv ?? 0)}
                                            value={CaracterizacaoEscola.equipmentResource.teachingLearning.tv}
                                            register={register("teachingLearning[0]")}
                                            onChange={e => setCaracterizacaoEscola({
                                                ...CaracterizacaoEscola, equipmentResource: {
                                                    ...CaracterizacaoEscola.equipmentResource, teachingLearning: {
                                                        ...CaracterizacaoEscola.equipmentResource.teachingLearning,
                                                        tv: e.target.value
                                                    }
                                                }
                                            })} />
                                    </Box50>
                                    <Box50 style={{ marginRight: 20 }}>
                                        <label className='LabelInput'>Aparelho de DVD/Blu-ray</label>
                                        <input className="input"
                                            name='teachingLearning[1]'
                                            register={register("teachingLearning[1]")}
                                            {...setValue('teachingLearning[1]', CaracterizacaoEscola.equipmentResource.teachingLearning.dvdPlayer ?? 0)}
                                            value={CaracterizacaoEscola.equipmentResource.teachingLearning.dvdPlayer}
                                            onChange={e => setCaracterizacaoEscola({
                                                ...CaracterizacaoEscola, equipmentResource: {
                                                    ...CaracterizacaoEscola.equipmentResource, teachingLearning: {
                                                        ...CaracterizacaoEscola.equipmentResource.teachingLearning,
                                                        dvdPlayer: e.target.value
                                                    }
                                                }
                                            })} />
                                    </Box50>
                                    <Box50>
                                        <label className='LabelInput'>Aparelho de Som</label>
                                        <input className="input"
                                            name='teachingLearning[2]'
                                            register={register("teachingLearning[2]")}
                                            {...setValue('teachingLearning[2]', CaracterizacaoEscola.equipmentResource.teachingLearning.stereo ?? 0)}
                                            value={CaracterizacaoEscola.equipmentResource.teachingLearning.stereo}
                                            onChange={e => setCaracterizacaoEscola({
                                                ...CaracterizacaoEscola, equipmentResource: {
                                                    ...CaracterizacaoEscola.equipmentResource, teachingLearning: {
                                                        ...CaracterizacaoEscola.equipmentResource.teachingLearning,
                                                        stereo: e.target.value
                                                    }
                                                }
                                            })} />
                                    </Box50>

                                </Box2Items>
                            </Box>
                            <Box3Items>
                                <Box30 style={{ marginRight: 20 }}>
                                    <label className='LabelInput'>Projetor multimídia (Data show)</label>
                                    <input className="input"
                                        name='teachingLearning[3]'
                                        register={register("teachingLearning[3]")}
                                        {...setValue('teachingLearning[3]', CaracterizacaoEscola.equipmentResource.teachingLearning.dataShow ?? 0)}
                                        value={CaracterizacaoEscola.equipmentResource.teachingLearning.dataShow}
                                        onChange={e => setCaracterizacaoEscola({
                                            ...CaracterizacaoEscola, equipmentResource: {
                                                ...CaracterizacaoEscola.equipmentResource, teachingLearning: {
                                                    ...CaracterizacaoEscola.equipmentResource.teachingLearning,
                                                    dataShow: e.target.value
                                                }
                                            }
                                        })} />
                                </Box30>
                                <Box30 >
                                    <label className='LabelInput'>Lousa digital</label>
                                    <input className="input"
                                        name='teachingLearning[4]'
                                        register={register("teachingLearning[4]")}
                                        {...setValue('teachingLearning[4]', CaracterizacaoEscola.equipmentResource.teachingLearning.digitalBlackboard ?? 0)}
                                        value={CaracterizacaoEscola.equipmentResource.teachingLearning.digitalBlackboard}
                                        onChange={e => setCaracterizacaoEscola({
                                            ...CaracterizacaoEscola, equipmentResource: {
                                                ...CaracterizacaoEscola.equipmentResource, teachingLearning: {
                                                    ...CaracterizacaoEscola.equipmentResource.teachingLearning,
                                                    digitalBlackboard: e.target.value
                                                }
                                            }
                                        })} />

                                </Box30>
                            </Box3Items>
                            <TitleFieldForm> {getTitleIndex('Quantidade de computadores em uso pelos alunos', 'pcStudents')} Quantidade de computadores em uso pelos alunos</TitleFieldForm>
                            <Box2Items>
                                <Box30>
                                    <label className='LabelInput'>Computadores de mesa (Desktop)</label>
                                    <input className="input"
                                        name='pcStudents[0]'
                                        {...register("pcStudent[0]")}
                                        {...setValue('pcStudents[0]', CaracterizacaoEscola.equipmentResource.pcStudents.desktopComputer ?? 0)}
                                        value={CaracterizacaoEscola.equipmentResource.pcStudents.desktopComputer}
                                        onChange={e => setCaracterizacaoEscola({
                                            ...CaracterizacaoEscola, equipmentResource: {
                                                ...CaracterizacaoEscola.equipmentResource, pcStudents: {
                                                    ...CaracterizacaoEscola.equipmentResource.pcStudents,
                                                    desktopComputer: e.target.value
                                                }
                                            }
                                        })} />
                                </Box30>
                                <Box30>
                                    <label className='LabelInput'>Computadores portáteis</label>
                                    <input className="input"
                                        name='pcStudents[1]'
                                        register={register("pcStudents[1]")}
                                        {...setValue('pcStudents[1]', CaracterizacaoEscola.equipmentResource.pcStudents.portableComputer ?? 0)}
                                        value={CaracterizacaoEscola.equipmentResource.pcStudents.portableComputer}
                                        onChange={e => setCaracterizacaoEscola({
                                            ...CaracterizacaoEscola, equipmentResource: {
                                                ...CaracterizacaoEscola.equipmentResource, pcStudents: {
                                                    ...CaracterizacaoEscola.equipmentResource.pcStudents,
                                                    portableComputer: e.target.value
                                                }
                                            }
                                        })} />
                                </Box30>
                                <Box30>
                                    <label className='LabelInput'>Tablets</label>
                                    <input className="input"
                                        name='pcStudents[2]'
                                        register={register("pcStudents[2]")}
                                        {...setValue('pcStudents[2]', CaracterizacaoEscola.equipmentResource.pcStudents.tablet ?? 0)}
                                        value={CaracterizacaoEscola.equipmentResource.pcStudents.tablet}
                                        onChange={e => setCaracterizacaoEscola({
                                            ...CaracterizacaoEscola, equipmentResource: {
                                                ...CaracterizacaoEscola.equipmentResource, pcStudents: {
                                                    ...CaracterizacaoEscola.equipmentResource.pcStudents,
                                                    tablet: e.target.value
                                                }
                                            }
                                        })} />
                                    <Message>{errors.pcStudents?.message}</Message>
                                </Box30>
                            </Box2Items>


                            <Box style={{ marginTop: 10 }}>
                                <TitleFieldForm>
                                    {getTitleIndex('rede local de interligação de computadores', 'localComputerNetwork')} rede local de interligação de computadores

                                </TitleFieldForm>
                                <Checkbox title='A cabo'
                                    name='localComputerNetwork[0]'
                                    setValue={setValue('localComputerNetwork[0]', CaracterizacaoEscola.equipmentResource.localComputerNetwork.cable)}
                                    register={register('localComputerNetwork[0]')}
                                    checked={CaracterizacaoEscola.equipmentResource.localComputerNetwork.cable === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, equipmentResource: {
                                            ...CaracterizacaoEscola.equipmentResource, localComputerNetwork: {
                                                ...CaracterizacaoEscola.equipmentResource.localComputerNetwork,
                                                cable: e.target.checked ? 1 : 0,
                                                noneLCP: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Wireless'
                                    name='localComputerNetwork[1]'
                                    setValue={setValue('localComputerNetwork[1]', CaracterizacaoEscola.equipmentResource.localComputerNetwork.wireless)}
                                    register={register('localComputerNetwork[1]')}
                                    checked={CaracterizacaoEscola.equipmentResource.localComputerNetwork.wireless === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, equipmentResource: {
                                            ...CaracterizacaoEscola.equipmentResource, localComputerNetwork: {
                                                ...CaracterizacaoEscola.equipmentResource.localComputerNetwork,
                                                wireless: e.target.checked ? 1 : 0,
                                                noneLCP: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Não há rede local interligando computadores'
                                    name='localComputerNetwork[2]'
                                    setValue={setValue('localComputerNetwork[2]', CaracterizacaoEscola.equipmentResource.localComputerNetwork.noneLCP)}
                                    register={register('localComputerNetwork[2]')}
                                    checked={CaracterizacaoEscola.equipmentResource.localComputerNetwork.noneLCP === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, equipmentResource: {
                                            ...CaracterizacaoEscola.equipmentResource, localComputerNetwork:
                                                IsNone(CaracterizacaoEscola.equipmentResource.localComputerNetwork, 'noneLCP')
                                        }
                                    })} />
                                <Message>{errors.localComputerNetwork?.message}</Message>
                            </Box>
                            <Box style={{ marginTop: 10 }}>
                                <TitleFieldForm>
                                    {getTitleIndex('Acesso a Internet', 'accessInternet')} Acesso a Internet
                                </TitleFieldForm>
                                <Checkbox title='Não possui acesso a internet'
                                    name='accessInternet[0]'
                                    setValue={setValue('accessInternet[0]', CaracterizacaoEscola.equipmentResource.accessInternet.noAccessInternet)}
                                    register={register("accessInternet[0]")}
                                    checked={CaracterizacaoEscola.equipmentResource.accessInternet.noAccessInternet === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, equipmentResource: {
                                            ...CaracterizacaoEscola.equipmentResource, accessInternet:
                                                IsNone(CaracterizacaoEscola.equipmentResource.accessInternet, 'noAccessInternet')
                                        }
                                    })} />
                                <Checkbox title='Para uso administrativo'
                                    name='accessInternet[1]'
                                    setValue={setValue('accessInternet[1]', CaracterizacaoEscola.equipmentResource.accessInternet.administrativeUse)}
                                    register={register("accessInternet[1]")}
                                    checked={CaracterizacaoEscola.equipmentResource.accessInternet.administrativeUse === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, equipmentResource: {
                                            ...CaracterizacaoEscola.equipmentResource, accessInternet: {
                                                ...CaracterizacaoEscola.equipmentResource.accessInternet,
                                                administrativeUse: e.target.checked ? 1 : 0,
                                                noAccessInternet: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Para uso da communidade'
                                    name='accessInternet[2]'
                                    setValue={setValue('accessInternet[2]', CaracterizacaoEscola.equipmentResource.accessInternet.communityUse)}
                                    register={register("accessInternet[2]")}
                                    checked={CaracterizacaoEscola.equipmentResource.accessInternet.communityUse === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, equipmentResource: {
                                            ...CaracterizacaoEscola.equipmentResource, accessInternet: {
                                                ...CaracterizacaoEscola.equipmentResource.accessInternet,
                                                communityUse: e.target.checked ? 1 : 0,
                                                noAccessInternet: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Para uso dos alunos'
                                    name='accessInternet[3]'
                                    value="aluno"
                                    setValue={setValue('accessInternet[3]', CaracterizacaoEscola.equipmentResource.accessInternet.studentUse)}
                                    register={register("accessInternet[3]")}
                                    checked={CaracterizacaoEscola.equipmentResource.accessInternet.studentUse === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, equipmentResource: {
                                            ...CaracterizacaoEscola.equipmentResource, accessInternet: {
                                                ...CaracterizacaoEscola.equipmentResource.accessInternet,
                                                studentUse: e.target.checked ? 1 : 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Para uso no processo de ensino e aprendizagem'
                                    name='accessInternet[4]'
                                    setValue={setValue('accessInternet[4]', CaracterizacaoEscola.equipmentResource.accessInternet.teachingLearning)}
                                    register={register("accessInternet[4]")}
                                    checked={CaracterizacaoEscola.equipmentResource.accessInternet.teachingLearning === 1 ? true : false}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, equipmentResource: {
                                            ...CaracterizacaoEscola.equipmentResource, accessInternet: {
                                                ...CaracterizacaoEscola.equipmentResource.accessInternet,
                                                teachingLearning: e.target.checked ? 1 : 0
                                            }
                                        }
                                    })} />
                                <Message>{errors.accessInternet?.message}</Message>
                            </Box>
                            <Box style={{ marginTop: 10, display: CaracterizacaoEscola.equipmentResource.accessInternet.noAccessInternet === 1 ? 'none' : 'block' }}>
                                <TitleFieldForm>
                                    {getTitleIndex('Internet Banda Larga', 'broadbandInternet')}
                                </TitleFieldForm>
                                <Select
                                    name='broadbandInternet'

                                    {...setValue('broadbandInternet', CaracterizacaoEscola.equipmentResource.broadbandInternet ?? -1)}
                                    {...register("broadbandInternet")}
                                    value={CaracterizacaoEscola.equipmentResource.broadbandInternet ?? -1}
                                    o onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, equipmentResource: {
                                            ...CaracterizacaoEscola.equipmentResource,
                                            broadbandInternet: e.target.value
                                        }
                                    })}>
                                    <Option value={-1} disabled hidden>selecione</Option>
                                    <Option value={0}>Não</Option>
                                    <Option value={1}>Sim</Option>
                                </Select>
                                <Message>{errors.broadbandInternet?.message}</Message>
                            </Box>
                            <Box style={{
                                marginTop: 10, display: CaracterizacaoEscola.equipmentResource.accessInternet.studentUse === 1
                                    && CaracterizacaoEscola.equipmentResource.pcStudents.desktopComputer > 1 ? 'block' : 'none'
                            }}>
                                <TitleFieldForm>
                                    {getTitleIndex('Equipamentos que os alunos usam para acessar a internet da escola', 'equipmentUsedAccessInternet')}
                                </TitleFieldForm>
                                <Checkbox title='Computadores de mesa, portáteis e tablets da escola (no laboratório de informática, biblioteca, sala de aula, etc.)'
                                    name='equipmentUsedAccessInternet[0]'
                                    value="1"
                                    setValue={setValue('equipmentUsedAccessInternet[0]', CaracterizacaoEscola.equipmentResource.equipmentUsedAccessInternet.computerTablet)}
                                    register={register("equipmentUsedAccessInternet[0]")}
                                    checked={CaracterizacaoEscola.equipmentResource.equipmentUsedAccessInternet.computerTablet === 1 ? true : false}
                                    disabled={CaracterizacaoEscola.equipmentResource.accessInternet.studentUse === 1
                                        && CaracterizacaoEscola.equipmentResource.pcStudents.desktopComputer > 1 ? false : true}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, equipmentResource: {
                                            ...CaracterizacaoEscola.equipmentResource, equipmentUsedAccessInternet: {
                                                ...CaracterizacaoEscola.equipmentResource.equipmentUsedAccessInternet,
                                                computerTablet: e.target.checked ? 1 : 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Dispositivos pessoais (computadores portáteis, celulares, tablets, etc.)'
                                    name='equipmentUsedAccessInternet[1]'
                                    value="2"
                                    setValue={setValue('equipmentUsedAccessInternet[1]', CaracterizacaoEscola.equipmentResource.equipmentUsedAccessInternet.personalDevice)}
                                    register={register("equipmentUsedAccessInternet[1]")}
                                    checked={CaracterizacaoEscola.equipmentResource.equipmentUsedAccessInternet.personalDevice === 1 ? true : false}
                                    disabled={CaracterizacaoEscola.equipmentResource.accessInternet.studentUse === 1
                                        && CaracterizacaoEscola.equipmentResource.localComputerNetwork.wireless === 1 ? false : true}

                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, equipmentResource: {
                                            ...CaracterizacaoEscola.equipmentResource, equipmentUsedAccessInternet: {
                                                ...CaracterizacaoEscola.equipmentResource.equipmentUsedAccessInternet,
                                                personalDevice: e.target.checked ? 1 : 0
                                            }
                                        }
                                    })} />
                                <Message>{errors.equipmentUsedAccessInternet?.message}</Message>
                            </Box>


                        </FormContent>
                        <TextLabel>
                            Recursos humanos
                        </TextLabel>
                        <FormContent style={{ marginTop: 20 }}>
                            <Box>
                                <TitleFieldForm>  {getTitleIndex('total de profissionais que atuam nas seguintes funções na escola', 'totalProfessionals')}<Madatory>*</Madatory></TitleFieldForm>
                                <label className='LabelInput'>Auxiliares de secretaria ou auxiliares administrativo, atendentes</label>
                                <InputResponsive1
                                    type="number"
                                    name={'totalProfessionals[0]'}
                                    maxlength='4'
                                    {...setValue('totalProfessionals[0]', CaracterizacaoEscola.totalProfessionals.secretaryAssistant ?? 0)}
                                    register={register('totalProfessionals[0]')}
                                    value={CaracterizacaoEscola.totalProfessionals.secretaryAssistant}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, totalProfessionals: {
                                            ...CaracterizacaoEscola.totalProfessionals,
                                            secretaryAssistant: e.target.value,
                                            noneTP: null
                                        }
                                    })} />
                                <label className='LabelInput'>Auxiliar de serviços gerais, porteiro(a), zelador(a), faxineiro(a), jardineiro(a)</label>
                                <InputResponsive1
                                    type='text'
                                    maxlength='4'
                                    name={'totalProfessionals[1]'}
                                    {...setValue('totalProfessionals[1]', CaracterizacaoEscola.totalProfessionals.generalServicesAssistant ?? 0)}
                                    register={register('totalProfessionals[1]')}

                                    value={CaracterizacaoEscola.totalProfessionals.generalServicesAssistant}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, totalProfessionals: {
                                            ...CaracterizacaoEscola.totalProfessionals,
                                            generalServicesAssistant: e.target.value,
                                            noneTP: null
                                        }
                                    })} />
                                <label className='LabelInput'>Bibliotecário(a), auxiliar de biblioteca ou monitor(a) da sala de leitura</label>
                                <InputResponsive1
                                    name={'totalProfessionals[2]'}
                                    maxlength='4'
                                    register={register('totalProfessionals[2]')}
                                    {...setValue('totalProfessionals[2]', CaracterizacaoEscola.totalProfessionals.librarian ?? 0)} value={CaracterizacaoEscola.totalProfessionals.librarian}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, totalProfessionals: {
                                            ...CaracterizacaoEscola.totalProfessionals,
                                            librarian: e.target.value,
                                            noneTP: null
                                        }
                                    })} />
                                <label className='LabelInput'>Bombeiro(a) brigadista, profissionais de assistência a saúde (urgência e emergência), enfermeiro(a), técnico(a) de enfermagem e socorrista</label>
                                <InputResponsive1
                                    type="number"
                                    name={'totalProfessionals[3]'}
                                    maxlength='4'
                                    {...setValue('totalProfessionals[3]', CaracterizacaoEscola.totalProfessionals.firemanHealthAssistantNurse ?? 0)}
                                    value={CaracterizacaoEscola.totalProfessionals.firemanHealthAssistantNurse}
                                    register={register('totalProfessionals[3]')}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, totalProfessionals: {
                                            ...CaracterizacaoEscola.totalProfessionals,
                                            firemanHealthAssistantNurse: e.target.value,
                                            noneTP: null
                                        }
                                    })} />
                                <label className='LabelInput'>Coordenador(a) de turno/disciplinar</label>
                                <InputResponsive1
                                    name={'totalProfessionals[4]'}
                                    maxlength='4'
                                    register={register('totalProfessionals[4]')}
                                    {...setValue('totalProfessionals[4]', CaracterizacaoEscola.totalProfessionals.classDisciplineCoordinator ?? 0)}
                                    value={CaracterizacaoEscola.totalProfessionals.classDisciplineCoordinator}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, totalProfessionals: {
                                            ...CaracterizacaoEscola.totalProfessionals,
                                            classDisciplineCoordinator: e.target.value,
                                            noneTP: null
                                        }
                                    })} />
                                <label className='LabelInput'>Fonoaudiólogo(a)</label>
                                <InputResponsive1
                                    name={'totalProfessionals[5]'}
                                    maxlength='4'
                                    register={register('totalProfessionals[5]')}
                                    {...setValue('totalProfessionals[5]', CaracterizacaoEscola.totalProfessionals.speechTherapist ?? 0)}
                                    value={CaracterizacaoEscola.totalProfessionals.speechTherapist}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, totalProfessionals: {
                                            ...CaracterizacaoEscola.totalProfessionals,
                                            speechTherapist: e.target.value,
                                            noneTP: null
                                        }
                                    })} />
                                <label className='LabelInput'>Nutricionista</label>
                                <InputResponsive1
                                    name={'totalProfessionals[6]'}
                                    maxlength='4'
                                    register={register('totalProfessionals[6]')}
                                    {...setValue('totalProfessionals[6]', CaracterizacaoEscola.totalProfessionals.nutritionist ?? 0)}
                                    value={CaracterizacaoEscola.totalProfessionals.nutritionist}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, totalProfessionals: {
                                            ...CaracterizacaoEscola.totalProfessionals,
                                            nutritionist: e.target.value,
                                            noneTP: null
                                        }
                                    })} />
                                <label className='LabelInput'>Psicólogo(a) escolar</label>
                                <InputResponsive1
                                    name={'totalProfessionals[7]'}
                                    maxlength='4'
                                    register={register('totalProfessionals[7]')}
                                    {...setValue('totalProfessionals[7]', CaracterizacaoEscola.totalProfessionals.psychology ?? 0)}
                                    value={CaracterizacaoEscola.totalProfessionals.psychology}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, totalProfessionals: {
                                            ...CaracterizacaoEscola.totalProfessionals,
                                            psychology: e.target.value,
                                            noneTP: null
                                        }
                                    })} />
                                <label className='LabelInput'>Profissionais de preparação e segurança alimentar, foodPreparationProfessionals(a), merendeira e auxiliar de cozinha</label>
                                <InputResponsive1
                                    name={'totalProfessionals[8]'}
                                    maxlength='4'
                                    register={register('totalProfessionals[8]')}
                                    {...setValue('totalProfessionals[8]', CaracterizacaoEscola.totalProfessionals.foodPreparationProfessionals ?? 0)}
                                    value={CaracterizacaoEscola.totalProfessionals.foodPreparationProfessionals}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, totalProfessionals: {
                                            ...CaracterizacaoEscola.totalProfessionals,
                                            foodPreparationProfessionals: e.target.value,
                                            noneTP: null
                                        }
                                    })} />
                                <label className='LabelInput'>Profissionais de apoio e supervisão pedagógica: (pedagogo(a), coordenador(a) pedagógico(a), orientador(a) educacional, supervisor(a) escolar e coordenador(a) de área de ensino)</label>
                                <InputResponsive1
                                    name={'totalProfessionals[9]'}
                                    maxlength='4'
                                    register={register('totalProfessionals[9]')}
                                    {...setValue('totalProfessionals[9]', CaracterizacaoEscola.totalProfessionals.professionalPedagogicalSupport ?? 0)}
                                    value={CaracterizacaoEscola.totalProfessionals.professionalPedagogicalSupport}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, totalProfessionals: {
                                            ...CaracterizacaoEscola.totalProfessionals,
                                            professionalPedagogicalSupport: e.target.value,
                                            noneTP: null
                                        }
                                    })} />
                                <label className='LabelInput'>Secretário(a) escolar</label>
                                <InputResponsive1
                                    name={'totalProfessionals[10]'}
                                    maxlength='4'
                                    register={register('totalProfessionals[10]')}
                                    {...setValue('totalProfessionals[10]', CaracterizacaoEscola.totalProfessionals.schoolSecretary ?? 0)} value={CaracterizacaoEscola.totalProfessionals.schoolSecretary}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, totalProfessionals: {
                                            ...CaracterizacaoEscola.totalProfessionals,
                                            schoolSecretary: e.target.value,
                                            noneTP: null
                                        }
                                    })} />
                                <label className='LabelInput'>Segurança, guarda ou segurança patrimonial</label>
                                <InputResponsive1
                                    name={'totalProfessionals[11]'}
                                    maxlength='4'
                                    register={register('totalProfessionals[11]')}
                                    {...setValue('totalProfessionals[11]', CaracterizacaoEscola.totalProfessionals.securityMan ?? 0)} value={CaracterizacaoEscola.totalProfessionals.securityMan}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, totalProfessionals: {
                                            ...CaracterizacaoEscola.totalProfessionals,
                                            securityMan: e.target.value,
                                            noneTP: null
                                        }
                                    })} />
                                <label className='LabelInput'>Técnicos(as), monitores(as), supervisores(as) ou auxiliares de laboratório(s), de apoio a tecnologias educacionais ou em multimeios/multimídias eletrônico-digitais.</label>
                                <InputResponsive1
                                    name={'totalProfessionals[12]'}
                                    register={register('totalProfessionals[12]')}
                                    {...setValue('totalProfessionals[12]', CaracterizacaoEscola.totalProfessionals.responsibleTechnology ?? 0)} value={CaracterizacaoEscola.totalProfessionals.responsibleTechnology}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, totalProfessionals: {
                                            ...CaracterizacaoEscola.totalProfessionals,
                                            responsibleTechnology: e.target.value,
                                            noneTP: null
                                        }
                                    })} />
                                <label className='LabelInput'>Vice-diretor(a) ou diretor(a) adjunto(a), profissionais responsáveis pela gestão administrativa e/ou financeiras</label>
                                <InputResponsive1
                                    name={'totalProfessionals[13]'}
                                    maxlength='4'
                                    register={register('totalProfessionals[13]')}
                                    {...setValue('totalProfessionals[13]', CaracterizacaoEscola.totalProfessionals.viceDirector ?? 0)} value={CaracterizacaoEscola.totalProfessionals.viceDirector}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, totalProfessionals: {
                                            ...CaracterizacaoEscola.totalProfessionals,
                                            viceDirector: e.target.value,
                                            noneTP: null
                                        }
                                    })} />
                                <label className='LabelInput'>Orientador(a) comunitário(a) ou assistente social</label>
                                <InputResponsive1
                                    name={'totalProfessionals[14]'}
                                    maxlength='4'
                                    register={register('totalProfessionals[14]')}
                                    {...setValue('totalProfessionals[14]', CaracterizacaoEscola.totalProfessionals.advisor ?? 0)} value={CaracterizacaoEscola.totalProfessionals.advisor}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, totalProfessionals: {
                                            ...CaracterizacaoEscola.totalProfessionals,
                                            advisor: e.target.value,
                                            noneTP: null
                                        }
                                    })} />
                                <label className='LabelInput'>Tradutor e Intérprete de Libras para atendimento em outros ambientes da escola que não seja sala de aula</label>
                                <InputResponsive1
                                    name={'totalProfessionals[15]'}
                                    maxlength='4'
                                    register={register('totalProfessionals[15]')}
                                    {...setValue('totalProfessionals[15]', CaracterizacaoEscola.totalProfessionals.librasTranslatorInterpreter ?? 0)} value={CaracterizacaoEscola.totalProfessionals.librasTranslatorInterpreter}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, totalProfessionals: {
                                            ...CaracterizacaoEscola.totalProfessionals,
                                            librasTranslatorInterpreter: e.target.value,
                                            noneTP: null
                                        }
                                    })} />
                                <label className='LabelInput'>Agrônomos(as), horticultores(as), técnicos ou monitores(as)
                                    responsáveis pela gestão da área de horta, plantio e/ou produção agrícola</label>
                                <Checkbox
                                    name={'totalProfessionals[16]'}
                                    register={register('totalProfessionals[16]')}
                                    maxlength='4'
                                    {...setValue('totalProfessionals[16]', CaracterizacaoEscola.totalProfessionals.agronomists ?? 0)}
                                    value={CaracterizacaoEscola.totalProfessionals.agronomists}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, totalProfessionals: {
                                            ...CaracterizacaoEscola.totalProfessionals,
                                            agronomists: e.target.value,
                                            noneTP: null
                                        }


                                    })} />
                                <label className='LabelInput'>Revisor de texto Braille, assistente vidente
                                    (assistente de revisão do texto em Braille)</label>
                                <Checkbox
                                    name={'totalProfessionals[17]'}
                                    register={register('totalProfessionals[17]')}
                                    maxlength='4'
                                    {...setValue('totalProfessionals[17]', CaracterizacaoEscola.totalProfessionals.brailleProofreader ?? 0)}
                                    value={CaracterizacaoEscola.totalProfessionals.brailleProofreader}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, totalProfessionals: {
                                            ...CaracterizacaoEscola.totalProfessionals,
                                            brailleProofreader: e.target.value,
                                            noneTP: null
                                        }
                                    })} />
                                <label className='LabelInput'>Não há funcionários para as funções listadas (Zera todos os valores do total de profissionais)</label>
                                <Checkbox
                                    name={'totalProfessionals[18]'}
                                    register={register('totalProfessionals[18]')}
                                    maxlength='4'
                                    {...setValue('totalProfessionals[18]', CaracterizacaoEscola.totalProfessionals.noneTP ?? 0)}
                                    value={CaracterizacaoEscola.totalProfessionals.noneTP}
                                    onChange={e => setCaracterizacaoEscola({
                                        ...CaracterizacaoEscola, totalProfessionals:
                                            IsNone(CaracterizacaoEscola.totalProfessionals, "noneTP")

                                    })} />
                                <Message>{errors.totalProfessionals?.message}</Message>
                            </Box>
                            <Box style={{ marginTop: 10 }}>
                                <TitleFieldForm>
                                    {getTitleIndex('Alimentação escolar para os alunos ', 'schoolFood')}<Madatory>*</Madatory>
                                </TitleFieldForm>
                                <Select
                                    name="schoolFood"
                                    {...register("schoolFood")}
                                    {...setValue('schoolFood', CaracterizacaoEscola.schoolFood ?? -1)}
                                    value={CaracterizacaoEscola.schoolFood}
                                    onChange={e => setCaracterizacaoEscola({ ...CaracterizacaoEscola, schoolFood: Number(e.target.value) })} >
                                    <Option key={-1} value={-1} disabled hidden>selecione</Option>
                                    <Option key={0} value={0}>Não oferece</Option>
                                    <Option key={1} value={1}>Oferece</Option>
                                </Select>
                                <Message>{errors.schoolFood?.message}</Message>
                            </Box>


                            <ButtonFormFooter
                                textNext="Próximo"
                                linkBack={"/escola/editar-identificacao"}
                            />
                        </FormContent>
                    </form>
                </Container>
            </App>
        </>
    )

}
export default Form2Escola